import { HttpClient } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'lib-preview-dialog',
  templateUrl: './preview-dialog.component.html',
  styleUrls: ['./preview-dialog.component.css'],
})
export class PreviewDialogComponent {
  previewUrl?: SafeResourceUrl;
  extension: any;
  previewAvailable: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<PreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer,
    private http: HttpClient,
  ) {
    this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      data.previewUrl,
    );
    this.extension = this.getFileExtension(data.previewUrl);
    if (this.extension === 'pdf' || this.extension === 'csv') {
      this.loadFile(data.previewUrl, this.extension);
    } else {
      this.previewAvailable = true;
    }
  }

  ngOnInit(): void {}

  getFileExtension(url: string): string {
    const urlSection = url.split('.');
    if (
      urlSection.length === 1 ||
      (urlSection[0] === '' && urlSection.length === 2)
    ) {
      return '';
    }
    return urlSection.pop()!.toLowerCase();
  }

  loadFile(url: string, fileType: string) {
    this.http
      .get(url, { responseType: 'arraybuffer' })
      .subscribe((response: ArrayBuffer) => {
        const blob = new Blob([response], { type: this.getMimeType(fileType) });
        const fileUrl = URL.createObjectURL(blob);
        this.previewUrl =
          this.sanitizer.bypassSecurityTrustResourceUrl(fileUrl);
      });
  }

  getMimeType(fileType: string): string {
    switch (fileType) {
      case 'pdf':
        return 'application/pdf';
      case 'csv':
        return 'text/plain';
      default:
        return '';
    }
  }
}
